import { createContext, useContext } from 'react';

export interface MessageType {
  type?: string;
  data?: any;
}

export interface RunPayrollMessageContextType {
  message: MessageType | null;
  setMessage: (message: MessageType | null) => void;
}

export const RunPayrollMessageContext = createContext<RunPayrollMessageContextType | null>(null);

export const useMessageContext = () => {
  return useContext(RunPayrollMessageContext);
};

export const MessageTypes = {
  "FINALIZED" : "FINALIZED",
  "EXECUTION_REQUESTED" : "EXECUTION_REQUESTED",
  "FINALIZE_IN_PROGRESS": "FINALIZE_IN_PROGRESS",
  "FINALIZED_ERROR_REPORT": "FINALIZED_ERROR_REPORT",
  // Resuming a stopped execution, as opposed to starting one. Separate from
  // EXECUTION_REQUESTED because that message is also used for a first-time
  // execute, where "running again" would be wrong.
  //
  // ONE message, deliberately, even though the backend does two different
  // things underneath — Compute either signals the stopped workflow to carry
  // on or supersedes it with a run over today's cohort ("action": "signaled" |
  // "re-executed"). That distinction is ours, not the admin's: either way the
  // same remaining employees get paid and money idempotency, keyed per person
  // on (payroll_staging_id, type, amount), means nobody is paid twice.
  //
  // Saying "a fresh run took over" would be mechanically precise and actively
  // harmful — on a payroll screen it reads as "pay everyone again", which is
  // the one thing an admin looking at a half-finished run is afraid of. Same
  // reason the word "retry" appears nowhere in this flow.
  "EXECUTION_RESUMED": "EXECUTION_RESUMED",
}

export interface SetMessageType {
  showMessage?: (message: MessageType | null) => void;
}